import React from 'react'
import * as R from 'ramda'
import { jt, t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { CategoryStatistics } from 'components/shared/CategoryStatistics/CategoryStatistics'
import { Chip } from 'components/shared/Chip/Chip'
import { CollapsableList } from 'components/shared/CollapsableList/CollapsableList'
import { NoteCard } from 'components/shared/NoteCard/NoteCard'

import { InterviewsCreatorStateContext } from 'components/modules/creators/TemplatesCreator/tabs/Interviews/context'
import { useContext } from 'hooks'

import { GridIcon, HelpCircleIcon } from 'components/shared/Icon/Icon'

import styles from './Aside.module.scss'

export const Aside = () => {
  const state = useContext(InterviewsCreatorStateContext)

  const { questionsCount, sectionsCount, steps } = state

  const message = (
    <span className={styles.bold} key="questions">{t`5-10 questions`}</span>
  )

  return (
    <Box className={styles.aside} direction="column" tagName="aside">
      <CategoryStatistics
        icon={GridIcon}
        label={t`Categories:`}
        value={sectionsCount}
      >
        <CollapsableList className={styles.list}>
          {R.map(
            ({ key, label, scoreable }) => (
              <CollapsableList.Item className={styles.item} {...{ key }}>
                <span className={styles.title}>{label || t`New category`}</span>
                <Chip
                  color={scoreable ? 'primary' : undefined}
                  label={scoreable ? t`Rated` : t`Unrated`}
                  size="small"
                  variant="filled"
                />
              </CollapsableList.Item>
            ),
            steps,
          )}
        </CollapsableList>
      </CategoryStatistics>
      <CategoryStatistics
        icon={HelpCircleIcon}
        label={t`Questions:`}
        value={questionsCount}
      />
      <NoteCard
        className={styles.card}
        text={jt`We suggest using ${message} during a 1-hour interview, which will provide the candidate with sufficient time to speak.`}
        title={t`Number of questions`}
      />
    </Box>
  )
}
